// extracted by mini-css-extract-plugin
export default {"container":"Info_container__MAA5r","information":"Info_information__9TDeO"};